export default __webpack_public_path__ + "static/media/YaysAppLogo.b9975462.webp";